import axios from 'axios'

export function findSmartUser(data) {
    return axios({
        method: 'post',
        url:'/user/smartUser/findSmartUser',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function getUserType(data) {
    return axios({
        method: 'get',
        url:'/user/common/getParamater?paratype='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function getUserPic(data) {
    return axios({
        method: 'get',
        url:'/user/smartUser/getUserPic?idebCard='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function getPassRecordByCode(data) {
    return axios({
        method: 'get',
        url:'/user/passRecord/getPassRecordByCode?sNumber='+data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function addSmartUser(data) {
    return axios({
        method: 'post',
        url:'/user/smartUser',
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function addSmartUserNew(data) {
    return axios({
        method: 'post',
        url:'/user/smartUser/new',
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function delSmartUser(data) {
    return axios({
        method: 'delete',
        url:'/user/smartUser?id='+data,
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function blackSmartUser(data) {
    return axios({
        method: 'get',
        url:'/user/smartUser/blackSmartUser?id='+data,
        data: data ,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}


export function getXdgj(data) {
    return axios({
        method: 'get',
        url:'/user/smartUser/getUserPersonLocus',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
export function getXdgjByFace(data) {
    return axios({
        method: 'post',
        url:'/user/smartUser/getUserPersonLocusByFace',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function selectCollege() {
    return axios({
        method: 'get',
        url:'/user/smartUser/selectCollege',
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function selectOrg() {
    return axios({
        method: 'get',
        url:'/user/smartUser/selectOrg',
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function selectParentOrg() {
    return axios({
        method: 'get',
        url:'/user/smartUser/selectParentOrg',
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function selectMajor() {
    return axios({
        method: 'get',
        url:'/user/smartUser/selectMajor',
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}
